// front/src/i18n/i18nBridge.js

let _t = (key, fallback) => (fallback ?? key);

/**
 * Call this once inside I18nProvider when i18n is ready
 * so non-React files (redux slices) can translate.
 */
export const setGlobalT = (tFn) => {
  if (typeof tFn === "function") _t = tFn;
};

/**
 * Safe translate function for everywhere (redux/services/etc)
 */
export const tt = (key, fallback) => _t(key, fallback);
